import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";

const RateCardDetailsForm = (props) => {
  const [cropVarietyData, setCropVarietyData] = useState([]);
  const currentDate = new Date().toISOString().substr(0, 10);
  const [croptypeId, setCroptypeId] = useState([]);
  const [cropId, setCropId] = useState([]);
  const [varietyId, setVarietyId] = useState([]);
  const [unitId, setUnitId] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [cropTypeList, setCropTypeList] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [cropFilterList, setCropFilterList] = useState([]);

  const [gradeData, setGradeData] = useState([]);

  const cropTypeOnchangedHandler = (event) => {
    var croptype = event.target.value;
    setVarietyId("")
    setCroptypeId(event.target.value);
    setCropFilterList([]);

    const cropFilterList = cropList.filter(
      (item) => parseInt(item.croptypeId) === parseInt(croptype)
    );

    setCropFilterList(cropFilterList);
  };

  const [varietyFilterList, setvarietyFilterList] = useState([]);

  const cropOnchangedHandler = (event) => {
    var crop_Id = event.target.value;
    setCropId(event.target.value);
    var varietyLis = cropVarietyData.filter((item) => item.cropId == crop_Id);
    setvarietyFilterList(varietyLis);
  };

  const { sendRequest: getcropType } = useHttp();
  useEffect(() => {
    getcropType(
      {
        url: "/api/croptypes/",
      },
      (res) => {
        if (res) {
          setCropTypeList(res);
        }
      }
    );
  }, [getcropType]);

  const { sendRequest: getcrop } = useHttp();
  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);
        }
      }
    );
  }, [getcrop]);

  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: "/api/varieties/",
      },
      (res) => {
        if (res) {
          setCropVarietyData(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          var unitFilter = res.filter((item) => item.unitTypeId == 2);
          setUnitList(unitFilter);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const { sendRequest: postRateCard } = useHttp();

  const rateCardsubmitHandler = (e) => {
    e.preventDefault();

    // console.log(gradeData);

    const data =
      gradeData &&
      gradeData.map((item, i) => ({
        gradeId: parseInt(item.gradeId),
        unitId: parseInt(unitId),
        gradeRateCardDate: moment(currentDate).format("DD/MM/YYYY"),
        rate: item.rate,
        quantity: 1,
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        createdDate: moment(currentDate).format("DD/MM/YYYY"),
      }));

    console.log(data);

    postRateCard(
      {
        url: "/api/gradeRateCard/",
        method: "POST",
        body: data,
      },
      (res) => {
        // console.log(res);
        toast.success(`Rate card detail added`);
        props.addForm(false);
      }
    );
  };
  const { sendRequest: getGradeData } = useHttp();
  useEffect(() => {
    setGradeData("");
    if (varietyId) {
      fetchGradeData(varietyId);
    }
  }, [varietyId, getGradeData]);

  const fetchGradeData = (varietyId) => {
    getGradeData(
      {
        url: `/api/fillgradeforgraderatecard/?orgId=${localStorage.getItem(
          "orgId"
        )}&varietyId=${varietyId}`,
      },
      (res) => {
        if (res) setGradeData(res);
      }
    );
  };

  const handleRateChange = (index, event) => {
    const newGradeData = [...gradeData];
    newGradeData[index].rate = parseInt(event.target.value);
    setGradeData(newGradeData);
  };

  useEffect(() => {
    if (props.update && cropTypeList.length > 0 && cropList.length > 0 && cropVarietyData.length > 0) {
      const cTypeId = props.update.croptypeId || 0;
      const cId = props.update.cropId || 0;
      const varietyId = props.update.varietyId || 0;
  
      setCroptypeId(cTypeId);

      const filteredCropList = cropList.filter(
        (item) => parseInt(item.croptypeId) === parseInt(cTypeId)
      );
      setCropFilterList(filteredCropList);
  
     
      setCropId(cId);
  
     
      const filteredVarietyList = cropVarietyData.filter(
        (item) => parseInt(item.cropId) === parseInt(cId)
      );
      setvarietyFilterList(filteredVarietyList);
  
      
      setVarietyId(varietyId);
  
   
      if (varietyId) {
        fetchGradeData(varietyId);
      }
      setUnitId(props.update.unitId);
    }
  }, [props.update, cropTypeList, cropList, cropVarietyData]);
  

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={rateCardsubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Rate Card Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Type</label>

                        <select
                          id="cropTypeNameId"
                          className="form-control"
                          value={croptypeId}
                          onChange={cropTypeOnchangedHandler}
                        >
                          <option value="">Select Crop Type</option>
                          {cropTypeList &&
                            cropTypeList.map((x) => (
                              <option
                                key={x.croptypeId}
                                croptype-id={x.croptypeId}
                                value={x.croptypeId}
                              >
                                {x.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Name </label>
                        <select
                          id="cropNameId"
                          className="form-control"
                          value={cropId}
                          onChange={cropOnchangedHandler}
                          required
                        >
                          <option value="">Select Crop</option>
                          {cropFilterList &&
                            cropFilterList.map((x) => (
                              <option
                                key={x.cropId}
                                crop-id={x.cropId}
                                value={x.cropId}
                              >
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Variety Name </label>
                        <select
                          id="varietyId"
                          className="form-control"
                          value={varietyId}
                          onChange={(e) => {
                            setVarietyId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Variety</option>
                          {varietyFilterList &&
                            varietyFilterList.map((x) => (
                              <option
                                key={x.varietyId}
                                variety-id={x.varietyId}
                                value={x.varietyId}
                              >
                                {x.varietyName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Quantity </label>

                        <input
                          type="text"
                          id="quantity"
                          className="form-control"
                          defaultValue={1}
                          autoComplete="off"
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit </label>

                        <select
                          id="unitId"
                          className="form-control"
                          value={unitId}
                          onChange={(e) => {
                            setUnitId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Unit</option>
                          {unitList &&
                            unitList.map((x) => (
                              <option
                                key={x.unitId}
                                unit-id={x.unitId}
                                value={x.unitId}
                              >
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Currency </label>
                        <input
                          type="text"
                          id="currency"
                          className="form-control"
                          value={localStorage.getItem("currencyCode") || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-7">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Grade</th>
                            <th>Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gradeData &&
                            gradeData.map((x, i) => (
                              <tr key={i}>
                                <td>{x.gradeName}</td>
                                <td className="w-25">
                                  {" "}
                                  <input
                                    type="number"
                                    id="rate"
                                    className="form-control text-right"
                                    autoComplete="off"
                                    value={x.rate}
                                    onChange={(e) => handleRateChange(i, e)}
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default RateCardDetailsForm;
